/* =========================================================
   ZUNDARO — interacciones
   Vanilla, sin librerias. Un solo archivo para todo el tema.
   ========================================================= */
(function () {
  'use strict';

  var menos = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var tactil = window.matchMedia('(hover: none)').matches;

  /* guard por elemento: re-ejecutar nunca duplica nada */
  function unaVez(el, clave) {
    clave = clave || 'zdInit';
    if (!el || el.dataset[clave] === '1') return false;
    el.dataset[clave] = '1';
    return true;
  }

  /* ---------------------------------------------- reveals */
  var observador = null;
  function initReveals(raiz) {
    var nodos = (raiz || document).querySelectorAll('.zd-reveal, [data-zd-subrayado]');
    if (!nodos.length) return;
    if (menos || !('IntersectionObserver' in window)) {
      nodos.forEach(function (n) { n.classList.add('zd-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('zd-visible');
            observador.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    }
    nodos.forEach(function (n) {
      if (!unaVez(n, 'zdRev')) return;
      observador.observe(n);
    });
  }

  /* ---------------------------------------------- heroe: la foto se asienta al cargar */
  function initHero(raiz) {
    (raiz || document).querySelectorAll('[data-zd-hero]').forEach(function (hero) {
      if (!unaVez(hero)) return;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { hero.classList.add('zd-listo'); });
      });
    });
  }

  /* ---------------------------------------------- bento: brillo que sigue al raton */
  function initBento(raiz) {
    if (tactil) return;
    (raiz || document).querySelectorAll('[data-zd-bento]').forEach(function (bento) {
      if (!unaVez(bento)) return;
      bento.addEventListener('pointermove', function (e) {
        var celda = e.target.closest('.zd-celda');
        if (!celda) return;
        var r = celda.getBoundingClientRect();
        celda.style.setProperty('--zd-mx', (e.clientX - r.left) + 'px');
        celda.style.setProperty('--zd-my', (e.clientY - r.top) + 'px');
      });
    });
  }

  /* ---------------------------------------------- cifras que cuentan hacia arriba */
  function initCifras(raiz) {
    (raiz || document).querySelectorAll('[data-zd-cifra]').forEach(function (el) {
      if (!unaVez(el)) return;
      var texto = el.textContent.trim();
      var m = texto.match(/^([^\d]*)(\d+(?:[.,]\d+)?)(.*)$/);
      if (!m || menos || !('IntersectionObserver' in window)) return;
      var antes = m[1], despues = m[3];
      var coma = m[2].indexOf(',') > -1;
      var objetivo = parseFloat(m[2].replace(',', '.'));
      var decimales = (m[2].split(/[.,]/)[1] || '').length;
      function pintar(v) {
        var s = v.toFixed(decimales);
        if (coma) s = s.replace('.', ',');
        el.textContent = antes + s + despues;
      }
      pintar(0);
      var obs = new IntersectionObserver(function (ent) {
        if (!ent[0].isIntersecting) return;
        obs.disconnect();
        var t0 = null, dur = 1400;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dur);
          pintar(objetivo * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      }, { threshold: 0.5 });
      obs.observe(el);
    });
  }

  /* ---------------------------------------------- pasos con pestanas + autoplay */
  function initPasos(raiz) {
    (raiz || document).querySelectorAll('[data-zd-pasos]').forEach(function (bloque) {
      if (!unaVez(bloque)) return;
      var pasos = bloque.querySelectorAll('.zd-paso');
      var imgs = bloque.querySelectorAll('.zd-pasos__media img');
      var media = bloque.querySelector('.zd-pasos__media');
      if (!pasos.length) return;
      var segundos = parseFloat(bloque.dataset.zdIntervalo || '5') || 5;
      bloque.style.setProperty('--zd-int', segundos + 's');
      var actual = 0;
      var temporizador = null;
      var visible = false;
      var auto = bloque.dataset.zdAuto === '1' && !menos;
      if (!auto) bloque.classList.add('zd-parado');

      function mostrar(i) {
        actual = (i + pasos.length) % pasos.length;
        pasos.forEach(function (p, k) {
          var on = k === actual;
          p.classList.toggle('zd-activo', on);
          p.setAttribute('aria-selected', on ? 'true' : 'false');
          /* reinicia la barra de progreso */
          var barra = p.querySelector('.zd-paso__barra i');
          if (barra && on) { barra.style.animation = 'none'; void barra.offsetWidth; barra.style.animation = ''; }
        });
        imgs.forEach(function (im, k) { im.classList.toggle('zd-activo', k === actual); });
        if (media) media.setAttribute('data-zd-num', (actual < 9 ? '0' : '') + (actual + 1) + ' / ' + (pasos.length < 10 ? '0' : '') + pasos.length);
        programar();
      }
      function programar() {
        clearTimeout(temporizador);
        if (!auto || !visible || bloque.classList.contains('zd-pausa')) return;
        temporizador = setTimeout(function () { mostrar(actual + 1); }, segundos * 1000);
      }
      pasos.forEach(function (p, k) {
        p.addEventListener('click', function () { mostrar(k); });
        p.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); mostrar(actual + 1); pasos[actual].focus(); }
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); mostrar(actual - 1); pasos[actual].focus(); }
        });
      });
      if (!tactil) {
        bloque.addEventListener('pointerenter', function () { bloque.classList.add('zd-pausa'); clearTimeout(temporizador); });
        bloque.addEventListener('pointerleave', function () { bloque.classList.remove('zd-pausa'); mostrar(actual); });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (ent) {
          visible = ent[0].isIntersecting;
          if (visible) mostrar(actual); else clearTimeout(temporizador);
        }, { threshold: 0.3 }).observe(bloque);
      }
      mostrar(0);
    });
  }

  /* ---------------------------------------------- quiz de recomendacion */
  function initQuiz(raiz) {
    (raiz || document).querySelectorAll('[data-zd-quiz]').forEach(function (quiz) {
      if (!unaVez(quiz)) return;
      var preguntas = quiz.querySelectorAll('.zd-quiz__preg');
      var resultados = quiz.querySelectorAll('.zd-quiz__res');
      var marcas = quiz.querySelectorAll('.zd-quiz__progreso i');
      if (!preguntas.length) return;
      var puntos = {};
      var actual = 0;

      function ir(i) {
        actual = i;
        preguntas.forEach(function (p, k) { p.classList.toggle('zd-activo', k === i); });
        resultados.forEach(function (r) { r.classList.remove('zd-activo'); });
        marcas.forEach(function (m, k) { m.classList.toggle('zd-hecho', k < i); });
      }
      function terminar() {
        var mejor = null, max = -1;
        resultados.forEach(function (r) {
          var clave = r.dataset.zdRes;
          var v = puntos[clave] || 0;
          if (v > max) { max = v; mejor = r; }
        });
        preguntas.forEach(function (p) { p.classList.remove('zd-activo'); });
        marcas.forEach(function (m) { m.classList.add('zd-hecho'); });
        if (mejor) mejor.classList.add('zd-activo');
      }
      quiz.querySelectorAll('.zd-quiz__op').forEach(function (op) {
        op.addEventListener('click', function () {
          var preg = op.closest('.zd-quiz__preg');
          preg.querySelectorAll('.zd-quiz__op').forEach(function (o) { o.classList.remove('zd-elegida'); });
          op.classList.add('zd-elegida');
          var clave = op.dataset.zdVa;
          puntos[clave] = (puntos[clave] || 0) + 1;
          setTimeout(function () {
            if (actual + 1 < preguntas.length) ir(actual + 1); else terminar();
          }, 320);
        });
      });
      quiz.querySelectorAll('[data-zd-reiniciar]').forEach(function (b) {
        b.addEventListener('click', function () {
          puntos = {};
          quiz.querySelectorAll('.zd-quiz__op').forEach(function (o) { o.classList.remove('zd-elegida'); });
          ir(0);
        });
      });
      ir(0);
    });
  }

  /* ---------------------------------------------- FAQ animado (details nativo) */
  function initFaq(raiz) {
    (raiz || document).querySelectorAll('.zd-faq__item').forEach(function (item) {
      if (!unaVez(item)) return;
      var sumario = item.querySelector('summary');
      if (item.open) item.classList.add('zd-abierto');
      if (!sumario || menos) {
        item.addEventListener('toggle', function () { item.classList.toggle('zd-abierto', item.open); });
        return;
      }
      sumario.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.open) {
          item.classList.remove('zd-abierto');
          setTimeout(function () { item.open = false; }, 420);
        } else {
          item.open = true;
          requestAnimationFrame(function () { item.classList.add('zd-abierto'); });
        }
      });
    });
  }

  /* ---------------------------------------------- boton magnetico */
  function initMagnetico(raiz) {
    if (tactil || menos) return;
    (raiz || document).querySelectorAll('[data-zd-iman]').forEach(function (btn) {
      if (!unaVez(btn)) return;
      var radio = 70;
      window.addEventListener('pointermove', function (e) {
        var r = btn.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2);
        var dy = e.clientY - (r.top + r.height / 2);
        if (Math.abs(dx) < r.width / 2 + radio && Math.abs(dy) < r.height / 2 + radio) {
          btn.style.transform = 'translate(' + (dx * 0.06).toFixed(1) + 'px,' + (dy * 0.14).toFixed(1) + 'px)';
        } else if (btn.style.transform) {
          btn.style.transform = '';
        }
      }, { passive: true });
    });
  }

  /* ---------------------------------------------- galeria de producto */
  function initGaleria(raiz) {
    (raiz || document).querySelectorAll('[data-zd-galeria]').forEach(function (gal) {
      if (!unaVez(gal)) return;
      var grande = gal.querySelector('.zd-prod__principal img');
      var tiras = gal.querySelectorAll('.zd-prod__tira');
      if (!grande || !tiras.length) return;
      tiras.forEach(function (t) {
        t.addEventListener('click', function () {
          var nueva = t.dataset.zdSrc;
          if (!nueva) return;
          grande.style.opacity = '0';
          setTimeout(function () {
            grande.src = nueva;
            grande.alt = t.dataset.zdAlt || grande.alt;
            grande.style.opacity = '1';
          }, 160);
          tiras.forEach(function (o) { o.classList.remove('zd-activo'); });
          t.classList.add('zd-activo');
        });
      });
    });
  }

  /* ---------------------------------------------- variantes del producto */
  function initVariantes(raiz) {
    (raiz || document).querySelectorAll('[data-zd-producto]').forEach(function (prod) {
      if (!unaVez(prod)) return;
      var datos = prod.querySelector('[data-zd-variantes]');
      var campoId = prod.querySelector('[data-zd-id]');
      if (!datos || !campoId) return;
      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      var grupos = prod.querySelectorAll('[data-zd-opcion]');
      if (!variantes || !variantes.length || !grupos.length) return;
      var precios = prod.querySelectorAll('[data-zd-precio-valor]');
      var ahorro = prod.querySelector('[data-zd-ahorro]');
      var antes = prod.querySelector('[data-zd-precio-antes]');
      var boton = prod.querySelector('[data-zd-anadir]');
      var botonTexto = prod.querySelector('[data-zd-anadir-texto]');
      var textoAnadir = boton ? boton.dataset.zdTexto : '';
      var textoAgotado = boton ? boton.dataset.zdAgotado : '';

      function actualizar() {
        var sel = [];
        grupos.forEach(function (g) {
          var marcada = g.querySelector('input:checked');
          sel.push(marcada ? marcada.value : null);
        });
        var v = null;
        for (var i = 0; i < variantes.length && !v; i++) {
          var ops = variantes[i].opciones || [];
          var igual = ops.length === sel.length;
          for (var k = 0; igual && k < sel.length; k++) if (ops[k] !== sel[k]) igual = false;
          if (igual) v = variantes[i];
        }
        if (!v) return;
        campoId.value = v.id;
        precios.forEach(function (p) { p.textContent = v.precio; });
        if (ahorro) { ahorro.textContent = v.ahorro ? ahorro.dataset.zdAhorroTexto + ' ' + v.ahorro : ''; ahorro.style.display = v.ahorro ? '' : 'none'; }
        if (antes) { antes.textContent = v.antes || ''; antes.style.display = v.antes ? '' : 'none'; }
        if (boton) {
          boton.disabled = !v.disponible;
          if (botonTexto) botonTexto.textContent = v.disponible ? textoAnadir : textoAgotado;
        }
      }
      grupos.forEach(function (g) { g.addEventListener('change', actualizar); });
    });
  }

  /* ---------------------------------------------- barra de compra fija (movil) */
  function initBarraFija(raiz) {
    (raiz || document).querySelectorAll('[data-zd-fija]').forEach(function (barra) {
      if (!unaVez(barra)) return;
      var prod = barra.closest('[data-zd-producto]');
      var boton = prod && prod.querySelector('[data-zd-anadir]');
      if (!boton || !('IntersectionObserver' in window)) return;
      // aparece cuando el boton principal ya quedo arriba, fuera de la pantalla
      new IntersectionObserver(function (ent) {
        var e = ent[0];
        var ver = !e.isIntersecting && e.boundingClientRect.top < 0;
        barra.classList.toggle('zd-visible', ver);
        barra.setAttribute('aria-hidden', ver ? 'false' : 'true');
        barra.querySelector('button').tabIndex = ver ? 0 : -1;
      }).observe(boton);
    });
  }

  /* ---------------------------------------------- registro: copiar codigo + ventana */
  var CLAVE_POP = 'zd-pop-visto';
  function guardar(k) { try { localStorage.setItem(k, '1'); } catch (e) {} }
  function leer(k) { try { return localStorage.getItem(k) === '1'; } catch (e) { return false; } }
  function initRegistro(raiz) {
    (raiz || document).querySelectorAll('[data-zd-copiar]').forEach(function (b) {
      if (!unaVez(b)) return;
      b.addEventListener('click', function () {
        var caja = b.closest('.zd-reg__codigo');
        var codigo = caja ? caja.querySelector('[data-zd-codigo]').textContent.trim() : '';
        var listo = function () { var t = b.textContent; b.textContent = b.dataset.zdCopiado || t; setTimeout(function () { b.textContent = t; }, 1800); };
        if (navigator.clipboard) navigator.clipboard.writeText(codigo).then(listo, listo); else listo();
      });
    });
    // ya registrado: la ventana no vuelve a salir
    if (document.querySelector('[data-zd-reg-ok]')) guardar(CLAVE_POP);
    (raiz || document).querySelectorAll('[data-zd-pop]').forEach(function (pop) {
      if (!unaVez(pop)) return;
      var form = pop.querySelector('form');
      var vieneDeAqui = form && form.id && location.hash === '#' + form.id;
      function abrir() {
        pop.hidden = false;
        void pop.offsetWidth; // fuerza el estilo inicial para que la transicion arranque
        pop.classList.add('zd-abierto');
        var campo = pop.querySelector('input[type=email]');
        if (campo) campo.focus({ preventScroll: true });
        guardar(CLAVE_POP);
      }
      function cerrar() {
        pop.classList.remove('zd-abierto');
        setTimeout(function () { pop.hidden = true; }, 300);
        guardar(CLAVE_POP);
      }
      pop.querySelectorAll('[data-zd-pop-cerrar]').forEach(function (c) { c.addEventListener('click', cerrar); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) cerrar(); });
      document.addEventListener('zd:abrir-registro', abrir);
      pop.dataset.zdListo = '1';
      if (vieneDeAqui) { abrir(); return; }
      if (leer(CLAVE_POP) || window.Shopify && window.Shopify.designMode) return;
      setTimeout(function () { if (!leer(CLAVE_POP)) abrir(); }, (parseInt(pop.dataset.zdPopEspera, 10) || 10) * 1000);
    });
  }

  /* ---------------------------------------------- tarjeta de rascar */
  var CLAVE_RASCA = 'zd-rasca-hecho';
  function initRasca(raiz) {
    (raiz || document).querySelectorAll('[data-zd-rasca]').forEach(function (caja) {
      if (!unaVez(caja)) return;
      var lienzo = caja.querySelector('canvas');
      var boton = caja.querySelector('[data-zd-abrir-registro]');
      var hecho = false;
      boton.addEventListener('click', function (e) {
        var pop = document.querySelector('[data-zd-pop][data-zd-listo]');
        if (!pop) return; // sin ventana: el enlace lleva al registro de la portada
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('zd:abrir-registro'));
      });
      function destapar() {
        if (hecho) return;
        hecho = true;
        caja.classList.add('zd-destapada');
        boton.tabIndex = 0;
        guardar(CLAVE_RASCA);
        setTimeout(function () { lienzo.remove(); }, 600);
      }
      // destapada: tocar cualquier parte del premio lleva al registro
      caja.querySelector('.zd-rasca__premio').addEventListener('click', function (e) {
        if (hecho && !e.target.closest('[data-zd-abrir-registro]')) boton.click();
      });
      if (leer(CLAVE_RASCA)) { destapar(); return; }

      var ctx = lienzo.getContext('2d');
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      function pintar() {
        var r = caja.getBoundingClientRect();
        if (!r.width) return;
        lienzo.width = Math.round(r.width * dpr); lienzo.height = Math.round(r.height * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.globalCompositeOperation = 'source-over';
        var g = ctx.createLinearGradient(0, 0, r.width, r.height);
        g.addColorStop(0, '#163B65'); g.addColorStop(.5, '#3B82C4'); g.addColorStop(1, '#163B65');
        ctx.fillStyle = g; ctx.fillRect(0, 0, r.width, r.height);
        // textura de puntos para que parezca una tarjeta de rascar
        ctx.fillStyle = 'rgba(255,255,255,.08)';
        for (var y = 6; y < r.height; y += 9) for (var x = (y % 18 ? 4 : 8); x < r.width; x += 9) ctx.fillRect(x, y, 2, 2);
        ctx.fillStyle = '#FFFFFF';
        ctx.font = '700 16px Montserrat, sans-serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.fillText('✦  ' + (caja.dataset.zdRascaTapa || '') + '  ✦', r.width / 2, r.height / 2);
      }
      pintar();
      window.addEventListener('resize', function () { if (!hecho) pintar(); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (!hecho) pintar(); });

      var rascando = false, trazos = 0;
      function punto(e) {
        var r = lienzo.getBoundingClientRect();
        return { x: e.clientX - r.left, y: e.clientY - r.top };
      }
      function rascar(p) {
        ctx.globalCompositeOperation = 'destination-out';
        ctx.beginPath(); ctx.arc(p.x, p.y, 22, 0, Math.PI * 2); ctx.fill();
        if (++trazos % 8 === 0) medir();
      }
      function medir() {
        // porcentaje rascado, mirando 1 de cada 16 pixeles
        var d = ctx.getImageData(0, 0, lienzo.width, lienzo.height).data, vacios = 0, total = 0;
        for (var i = 3; i < d.length; i += 64) { total++; if (d[i] === 0) vacios++; }
        if (vacios / total > .45) destapar();
      }
      lienzo.addEventListener('pointerdown', function (e) { rascando = true; lienzo.setPointerCapture(e.pointerId); rascar(punto(e)); });
      lienzo.addEventListener('pointermove', function (e) { if (rascando) rascar(punto(e)); });
      ['pointerup', 'pointercancel'].forEach(function (t) { lienzo.addEventListener(t, function () { rascando = false; if (!hecho) medir(); }); });
      lienzo.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); destapar(); } });
    });
  }

  /* ---------------------------------------------- arranque */
  function initTodo(ev) {
    var raiz = (ev && ev.target && ev.target.querySelectorAll) ? ev.target : document;
    initReveals(raiz);
    initHero(raiz);
    initBento(raiz);
    initCifras(raiz);
    initPasos(raiz);
    initQuiz(raiz);
    initFaq(raiz);
    initMagnetico(raiz);
    initGaleria(raiz);
    initVariantes(raiz);
    initBarraFija(raiz);
    initRegistro(raiz);
    initRasca(raiz);
  }

  if (window.__zdInit) return;
  window.__zdInit = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  } else {
    initTodo();
  }
  /* el editor de Shopify re-renderiza secciones sin recargar la pagina */
  document.addEventListener('shopify:section:load', initTodo);
})();
